import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { ALL_ARTICLES, SECTIONS, getArticle } from "@/help/articles/index";
import MarkdownContent from "@/help/MarkdownContent";

export default function HelpPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSlug = searchParams.get("article") || "dashboard";
  const [activeSlug, setActiveSlug] = useState(initialSlug);

  useEffect(() => {
    const slug = searchParams.get("article");
    if (slug) setActiveSlug(slug);
  }, [searchParams]);

  function selectArticle(slug) {
    setActiveSlug(slug);
    setSearchParams({ article: slug }, { replace: true });
  }

  const activeArticle = getArticle(activeSlug) || ALL_ARTICLES[0];

  return (
    <div className="flex gap-0 min-h-[calc(100vh-8rem)]">
      <nav
        className="hidden md:flex flex-col w-56 shrink-0 border-r pr-0"
        style={{ borderColor: "var(--fb-border)" }}
      >
        <div className="flex items-center gap-2 mb-5">
          <BookOpen className="w-5 h-5" style={{ color: "var(--fb-text-muted)" }} />
          <h1 className="text-lg font-bold" style={{ fontFamily: "Outfit", color: "var(--fb-text)" }}>
            Help Center
          </h1>
        </div>

        {SECTIONS.map((section) => {
          const articles = ALL_ARTICLES.filter((a) => a.section === section);
          if (!articles.length) return null;
          return (
            <div key={section} className="mb-4">
              <div
                className="text-xs uppercase tracking-wider font-semibold px-3 mb-1"
                style={{ color: "#8B918B" }}
              >
                {section}
              </div>
              {articles.map((article) => (
                <button
                  key={article.slug}
                  onClick={() => selectArticle(article.slug)}
                  className={`w-full text-left px-3 py-1.5 rounded-lg text-sm transition-colors ${
                    activeSlug === article.slug ? "font-medium" : ""
                  }`}
                  style={{
                    color: activeSlug === article.slug ? "var(--fb-text)" : "var(--fb-text-muted)",
                    background: activeSlug === article.slug ? "var(--fb-border)" : "transparent",
                  }}
                >
                  {article.title}
                </button>
              ))}
            </div>
          );
        })}
      </nav>

      <div className="flex-1 md:pl-8 min-w-0">
        <div className="md:hidden mb-4">
          <select
            value={activeSlug}
            onChange={(e) => selectArticle(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
            style={{ borderColor: "var(--fb-border)", background: "var(--fb-bg)", color: "var(--fb-text)" }}
          >
            {SECTIONS.map((section) => {
              const articles = ALL_ARTICLES.filter((a) => a.section === section);
              if (!articles.length) return null;
              return (
                <optgroup key={section} label={section}>
                  {articles.map((article) => (
                    <option key={article.slug} value={article.slug}>
                      {article.title}
                    </option>
                  ))}
                </optgroup>
              );
            })}
          </select>
        </div>

        {activeArticle && (
          <div className="max-w-2xl">
            <MarkdownContent content={activeArticle.content} />
          </div>
        )}
      </div>
    </div>
  );
}
